import {RootState} from "../../../../../app/store";
import {OfferFormSelectionProvider, OfferRequestPartial} from "../createAndUpdate/OfferForm";
import {Currency, OfferSource, OfferStatus, OfferType, UpdateSubtractionRequest} from "../../../../../api/generated";

export const createOfferRequestPropertySelector = (rootSelector: (state: RootState) => OfferRequestPartial): OfferFormSelectionProvider => ({
    publicId(state: RootState): string | undefined {
        return rootSelector(state).publicId;
    },
    publicBotId(state: RootState): string | undefined {
        return rootSelector(state).publicBotId;
    },
    publicLocationId(state: RootState): string | undefined {
        return rootSelector(state).publicLocationId;
    },
    offerStatus(state: RootState): OfferStatus | undefined {
        return rootSelector(state).offerStatus;
    },
    archivedAt(state: RootState): string | undefined {
        return rootSelector(state).archivedAt;
    },
    offerType(state: RootState): OfferType | undefined {
        return rootSelector(state).offerType;
    },
    offerSource(state: RootState): OfferSource | undefined {
        return rootSelector(state).offerSource;
    },
    offerSourceName(state: RootState): string | undefined {
        return rootSelector(state).offerSourceName;
    },
    title(state: RootState): string | undefined {
        return rootSelector(state).title;
    },
    description(state: RootState): string | undefined {
        return rootSelector(state).description;
    },
    make(state: RootState): string | undefined {
        return rootSelector(state).make;
    },
    model(state: RootState): string | undefined {
        return rootSelector(state).model;
    },
    startDate(state: RootState): string | undefined {
        return rootSelector(state).startDate;
    },
    endDate(state: RootState): string | undefined {
        return rootSelector(state).endDate;
    },
    redirectUrl(state: RootState): string | undefined {
        return rootSelector(state).redirectUrl;
    },
    imageUrl(state: RootState): string | undefined {
        return rootSelector(state).imageUrl;
    },
    discount(state: RootState): UpdateSubtractionRequest | undefined {
        return rootSelector(state).discount;
    },
    currency(state: RootState): Currency | undefined {
        return rootSelector(state).currency;
    },
    financeProduct(state: RootState): string | undefined {
        return rootSelector(state).financeProduct;
    },
    cashPrice(state: RootState): number | undefined {
        return rootSelector(state).cashPrice;
    },
    monthlyPayments(state: RootState): number | undefined {
        return rootSelector(state).monthlyPayments;
    },
    customerDeposit(state: RootState): number | undefined {
        return rootSelector(state).customerDeposit;
    },
    manufacturerDepositContribution(state: RootState): number | undefined {
        return rootSelector(state).manufacturerDepositContribution;
    },
    totalDeposit(state: RootState): number | undefined {
        return rootSelector(state).totalDeposit;
    },
    dealerContribution(state: RootState): number | undefined {
        return rootSelector(state).dealerContribution;
    },
    balanceToFinance(state: RootState): number | undefined {
        return rootSelector(state).balanceToFinance;
    },
    totalAmountPayable(state: RootState): number | undefined {
        return rootSelector(state).totalAmountPayable;
    },
    totalChargeForCredit(state: RootState): number | undefined {
        return rootSelector(state).totalChargeForCredit;
    },
    optionalFinalPayment(state: RootState): number | undefined {
        return rootSelector(state).optionalFinalPayment;
    },
    durationOfAgreementInMonths(state: RootState): number | undefined {
        return rootSelector(state).durationOfAgreementInMonths;
    },
    apr(state: RootState): number | undefined {
        return rootSelector(state).apr;
    },
    fixedInterestRate(state: RootState): number | undefined {
        return rootSelector(state).fixedInterestRate;
    },
    mileagePerAnnum(state: RootState): number | undefined {
        return rootSelector(state).mileagePerAnnum;
    },
    excessMileageCharge(state: RootState): number | undefined {
        return rootSelector(state).excessMileageCharge;
    }
});
